import { createFileRoute } from "@tanstack/react-router";
import { marketingHead } from "../marketing-content/head";
import { MarketingCompanyKnowledgePage } from "../components/marketing/MarketingCompanyKnowledgePage";

export const Route = createFileRoute("/product/company-knowledge")({
  head: () => marketingHead("/product/company-knowledge"),
  component: MarketingCompanyKnowledgePage,
});
